import React, { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./routes/AppRoutes";
import AccountProvider from "./components/context/AccountProvider";
import { KronicleAuthProvider } from "./auth";
import { cognitoConfig } from "./configs/aws-cognito";

function App() {
  useEffect(() => {
    const extractAndStoreToken = () => {
      let token = null;

      // Try normal URL params
      try {
        const urlParams = new URLSearchParams(window.location.search);
        token = urlParams.get("token");
      } catch (error) {
        console.error("Error parsing URL parameters:", error);
      }

      // Try malformed URL pattern fallback
      if (!token) {
        const url = window.location.href;
        const tokenMatch = url.match(/[?&]token=([^&]+)/);
        if (tokenMatch && tokenMatch[1]) {
          token = tokenMatch[1];
        }
      }

      if (token) {
        const existing = localStorage.getItem("token");

        // If the token in URL is same as stored, clean URL without reloading
        if (existing === token) {
          const cleanUrl = window.location.href.replace(/[?&]token=[^&]+/, "");
          window.history.replaceState({}, document.title, cleanUrl);
          return;
        }

        localStorage.setItem("token", token);

        // Clean URL parameter
        const cleanUrl = window.location.href.replace(/[?&]token=[^&]+/, "");
        window.history.replaceState({}, document.title, cleanUrl);

        // Check if there was a saved redirect destination
        const redirectUrl = localStorage.getItem("redirectAfterLogin");
        if (redirectUrl) {
          localStorage.removeItem("redirectAfterLogin");
          window.location.href = redirectUrl;
        } else {
          window.location.reload();
        }
      }
    };

    extractAndStoreToken();
  }, []);

  return (
    <KronicleAuthProvider amplifyOptions={cognitoConfig}>
      <AccountProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </AccountProvider>
    </KronicleAuthProvider>
  );
}

export default App;